export const hotVideos = [
  {
    id: 'v-001',
    title: '某顶流网红直播间翻车现场，粉丝集体脱粉回踩',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20streaming%20studio%20scene%20with%20a%20shocked%20streamer%20at%20a%20desk%2C%20dramatic%20red%20and%20amber%20lighting%2C%20chat%20messages%20flying%20on%20screen%2C%20tense%20atmosphere%2C%20cinematic%20lighting%2C%20editorial%20photography%20style%2C%20dark%20moody%20background%2C%20high%20contrast&width=800&height=600&seq=chigua-video-001&orientation=landscape',
    tag: '热榜第一',
    views: '328万',
    updateTime: '2小时前',
    category: 'wanghong',
    slug: 'dingliu-wanghong-zhibo-fanche',
    excerpt: '知名千万粉丝网红在最新直播中因不当言论引发众怒，弹幕区瞬间炸锅，大量老粉纷纷表示脱粉。',
    content: '',
    author: '吃瓜前线',
    publishedAt: '2026-07-07T08:00:00+08:00',
  },
  {
    id: 'v-002',
    title: '娱乐圈最新大瓜：当红小生深夜密会神秘女子',
    cover: 'https://readdy.ai/api/search-image?query=Nighttime%20street%20scene%20with%20a%20celebrity%20figure%20walking%20in%20shadows%2C%20paparazzi%20flash%20effect%2C%20mysterious%20atmosphere%2C%20warm%20street%20lights%20glow%2C%20cinematic%20noir%20style%2C%20dark%20alley%20with%20amber%20lighting%2C%20editorial%20photography&width=800&height=600&seq=chigua-video-002&orientation=landscape',
    tag: '独家爆料',
    views: '256万',
    updateTime: '4小时前',
    category: 'mingxing',
    slug: 'danghong-xiaosheng-mihui',
    excerpt: '记者深夜蹲守拍到某当红流量小生与一神秘女子共进晚餐后同回公寓，全程亲密互动不断。',
    content: '',
    author: '娱乐侦探',
    publishedAt: '2026-07-07T04:00:00+08:00',
  },
  {
    id: 'v-003',
    title: '延禧攻略全集高清在线观看，重温经典宫斗大戏',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20palace%20drama%20scene%20with%20elegant%20actress%20in%20traditional%20imperial%20costume%2C%20warm%20golden%20lantern%20lighting%2C%20ornate%20palace%20interior%2C%20soft%20cinematic%20atmosphere%2C%20rich%20red%20and%20gold%20color%20palette%2C%20editorial%20photography&width=800&height=600&seq=chigua-video-003&orientation=landscape',
    tag: '经典回顾',
    views: '189万',
    updateTime: '6小时前',
    category: 'remen',
    slug: 'yanxi-gonglue-quanji',
    excerpt: '延禧攻略全集资源整理，魏璎珞从宫女到皇贵妃的逆袭之路，每一集都让人欲罢不能。',
    content: '',
    author: '剧荒拯救者',
    publishedAt: '2026-07-07T02:00:00+08:00',
  },
  {
    id: 'v-004',
    title: '网红CP官宣分手，双方互爆猛料聊天记录曝光',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20split%20scene%20concept%2C%20two%20smartphones%20facing%20each%20other%20with%20cracked%20screens%2C%20chat%20bubbles%20floating%20in%20air%2C%20dramatic%20amber%20and%20crimson%20lighting%2C%20emotional%20atmosphere%2C%20editorial%20photography%20style%2C%20dark%20background&width=800&height=600&seq=chigua-video-004&orientation=landscape',
    tag: '最新爆料',
    views: '412万',
    updateTime: '1小时前',
    category: 'wanghong',
    slug: 'wanghong-cp-fenshou',
    excerpt: '曾经甜蜜互动的百万粉丝CP突然官宣分手，双方在社交平台隔空互撕，大量私密聊天记录被曝光。',
    content: '',
    author: '吃瓜前线',
    publishedAt: '2026-07-07T07:00:00+08:00',
  },
];

export const categories = [
  {
    id: 'cat-1',
    name: '网红黑料',
    slug: 'wanghong',
    description: '网红塌房现场、黑料猛料实时追踪',
    icon: 'ri-user-search-line',
    count: 1286,
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20social%20media%20influencer%20scene%20concept%2C%20multiple%20smartphones%20displaying%20social%20feeds%2C%20red%20notification%20bubbles%2C%20dark%20atmospheric%20background%20with%20warm%20amber%20highlights%2C%20editorial%20photography%20style%2C%20cinematic%20mood&width=600&height=600&seq=chigua-cat-wanghong&orientation=squarish',
  },
  {
    id: 'cat-2',
    name: '明星八卦',
    slug: 'mingxing',
    description: '娱乐圈最新动态、明星私生活揭秘',
    icon: 'ri-star-line',
    count: 953,
    image: 'https://readdy.ai/api/search-image?query=Red%20carpet%20event%20scene%20with%20camera%20flashes%2C%20glamorous%20vibe%2C%20dark%20background%20with%20golden%20spotlights%2C%20paparazzi%20style%2C%20editorial%20photography%2C%20dramatic%20atmosphere%2C%20warm%20tone&width=600&height=600&seq=chigua-cat-mingxing&orientation=squarish',
  },
  {
    id: 'cat-3',
    name: '热门吃瓜',
    slug: 'remen',
    description: '全网最火吃瓜视频、精彩合集一网打尽',
    icon: 'ri-fire-line',
    count: 2105,
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20content%20aggregation%20concept%2C%20multiple%20colorful%20video%20thumbnails%20floating%2C%20warm%20gradient%20background%2C%20trending%20topic%20vibe%2C%20editorial%20photography%20style%2C%20modern%20social%20media%20aesthetic&width=600&height=600&seq=chigua-cat-remen&orientation=squarish',
  },
  {
    id: 'cat-4',
    name: '国产吃瓜',
    slug: 'guochan',
    description: '国产剧集精彩片段、经典剧情回顾',
    icon: 'ri-movie-line',
    count: 876,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20production%20scene%20concept%2C%20director%20chair%20and%20film%20clapperboard%2C%20warm%20studio%20lighting%2C%20traditional%20Chinese%20elements%2C%20editorial%20photography%2C%20cinematic%20atmosphere&width=600&height=600&seq=chigua-cat-guochan&orientation=squarish',
  },
  {
    id: 'cat-5',
    name: '塌房现场',
    slug: 'tafang',
    description: '网红明星翻车实录、塌房名场面合集',
    icon: 'ri-alert-line',
    count: 634,
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20collapsing%20stage%20concept%2C%20broken%20spotlight%20on%20empty%20stage%2C%20dark%20theatrical%20atmosphere%20with%20red%20warning%20glow%2C%20editorial%20photography%2C%20intense%20mood%2C%20cinematic%20lighting&width=600&height=600&seq=chigua-cat-tafang&orientation=squarish',
  },
  {
    id: 'cat-6',
    name: '吃瓜合集',
    slug: 'heji',
    description: '一周吃瓜精华汇总，不错过任何大瓜',
    icon: 'ri-archive-line',
    count: 452,
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20newspaper%20headlines%20and%20tabloid%20covers%20in%20artistic%20arrangement%2C%20warm%20lighting%2C%20editorial%20photography%2C%20dark%20background%20with%20golden%20highlights%2C%20dramatic%20atmosphere&width=600&height=600&seq=chigua-cat-heji&orientation=squarish',
  },
];

export const hotReviews = [
  {
    id: 'rv-1',
    userName: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20young%20person%20avatar%20in%20modern%20flat%20illustration%20style%2C%20trendy%20aesthetic%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20clean%20minimalist%20design&width=80&height=80&seq=chigua-avatar-01&orientation=squarish',
    rating: 4.9,
    content: '"这个网站真的太懂我了！每天打开第一件事就是来这里看看有没有新瓜，更新速度快得惊人，内容也很全面，网红圈娱乐圈的大瓜一个都不会错过。推荐给所有爱吃瓜的姐妹们！"',
    level: '资深吃瓜群众',
  },
  {
    id: 'rv-2',
    userName: '八卦小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20young%20person%20avatar%20in%20modern%20flat%20illustration%20style%2C%20cool%20casual%20vibe%2C%20warm%20terracotta%20and%20beige%20palette%2C%20clean%20minimalist%20design&width=80&height=80&seq=chigua-avatar-02&orientation=squarish',
    rating: 4.8,
    content: '"国产吃瓜视频这块做得太棒了，延禧攻略全集都能在这里找到高清资源，画质清晰播放流畅。而且网红黑料的追踪速度比微博热搜还快，真心推荐！"',
    level: '铁杆粉丝',
  },
  {
    id: 'rv-3',
    userName: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20young%20person%20avatar%20in%20modern%20flat%20illustration%20style%2C%20night%20owl%20aesthetic%2C%20warm%20golden%20and%20brown%20palette%2C%20clean%20minimalist%20design&width=80&height=80&seq=chigua-avatar-03&orientation=squarish',
    rating: 4.7,
    content: '"作为一个资深吃瓜爱好者，这个网站的体验真的没话说。页面简洁大方，视频加载很快，分类也很清晰。关键是每天都有新内容，塌房现场的合集看得太过瘾了！"',
    level: '忠实用户',
  },
];

export const siteStats = {
  dailyVisits: '580万',
  totalVideos: '1.2万',
  activeUsers: '230万',
  updateFrequency: '每日更新',
};

export const aboutInfo = {
  title: '关于吃瓜视频',
  subtitle: '🍉 你身边的吃瓜第一站',
  description: '吃瓜视频成立于2023年，是国内领先的娱乐八卦内容聚合平台。我们致力于为用户提供最新、最全、最热的吃瓜视频内容，涵盖网红黑料追踪、明星八卦爆料、热门剧集回顾等多个领域。团队坚持每日更新，确保每一位吃瓜群众都能第一时间获取最新资讯。',
  mission: '让每一个瓜都被吃到',
  values: ['真实可靠', '更新迅速', '内容全面', '用户体验至上'],
};